import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import { Home, ClipboardCheck, MapPin, History, Wallet } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { AppLayout } from "@/components/ui-system";

const RiderLayout = ({ children, user, onLogout }) => {
  const location = useLocation();
  const [isCheckedIn, setIsCheckedIn] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchAttendanceStatus = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API}/rider/attendance/today`);
      setIsCheckedIn(res.data.is_checked_in);
    } catch (e) {
      console.error("Failed to fetch attendance status:", e);
      setIsCheckedIn(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchAttendanceStatus(); }, []);
  useEffect(() => { if (location.pathname === "/rider") fetchAttendanceStatus(); }, [location.pathname]);

  const nav = [
    { name: "Dashboard", path: "/rider", icon: Home, testId: "nav-dashboard", end: true },
    { name: "Attendance", path: "/rider/attendance", icon: ClipboardCheck, testId: "nav-attendance" },
    { name: "Trips", path: "/rider/trips", icon: MapPin, testId: "nav-trips" },
    { name: "History", path: "/rider/history", icon: History, testId: "nav-history" },
    { name: "COD", path: "/rider/cod", icon: Wallet, testId: "nav-cod" },
  ];

  const headerBadge = !loading ? (
    <Badge className={`text-[10px] px-1.5 py-0 border-0 ${isCheckedIn ? "bg-green-100 text-green-700" : "bg-slate-100 text-slate-500"}`}>
      {isCheckedIn ? "On Duty" : "Off Duty"}
    </Badge>
  ) : null;

  return (
    <AppLayout
      variant="mobile-tabs"
      accent="orange"
      brand={{ name: "Rider" }}
      nav={nav}
      user={user}
      onLogout={onLogout}
      headerBadge={headerBadge}
      headerSubtitle={user?.assigned_asset_name || "Pharmeasy"}
    >
      {children}
    </AppLayout>
  );
};

export default RiderLayout;
